export function getInitials(name: string | undefined) {
  return (
    name
      ?.split(" ")
      .slice(0, 2)
      .map((name) => name.slice(0, 1).toUpperCase())
      .join("") ?? ""
  );
}
